import { go as fuzzySort } from 'fuzzysort';

import { FuzzySearchOptions } from './types';

function fuzzySearch<TElement = unknown>(
    items: TElement[],
    options?: Partial<FuzzySearchOptions>,
): (searchString: string) => TElement[] {
    return (searchString: string) => {
        return fuzzySort(searchString, items, {
            all: true,
            threshold: -10000,
            keys: [],
            ...options,
        }).map((x) => x.obj);
    };
}

export default fuzzySearch;
